import { ROTransaction, RWTransaction } from '../../../db'
import { Context, Entity, Id, Order, PaginatedResult, Paging } from '../../../common'

export interface CardIssuePoint extends Entity {
  municipalEntityId: Id
  number: number
  locality: string
  street?: string
  building?: string
  comment?: string
  windowsCount: number
  openingHours?: string
  phone?: string
  responsiblePersonId?: Id
}

export interface CardIssuePointFilter {
  ids?: Id[]
  /**
   * Full text search by locality, street, building, comment
   */
  search?: string
  municipalEntityId?: Id
  number?: number
}

export type AddCardIssuePointOpts = {
  municipalEntityId: Id
  number: number
  locality: string
  street?: string
  building?: string
  comment?: string
  windowsCount: number
  openingHours?: string
  phone?: string
  responsiblePersonId?: Id
}

export type UpdateCardIssuePointOpts = {
  municipalEntityId?: Id
  number?: number
  locality?: string
  street?: string
  building?: string
  comment?: string
  windowsCount?: number
  openingHours?: string
  phone?: string
  responsiblePersonId?: Id | null
}

export enum CardIssuePointOrderFields {
  WINDOWS_COUNT = 'windowsCount',
  NUMBER = 'number',
  CREATED_AT = 'createdAt',
}

export interface CardIssuePointFindOptions {
  filter?: CardIssuePointFilter
  order?: Order<CardIssuePointOrderFields>
  paging?: Paging
}

export function cardIssuePointGetAddress(cardIssuePoint: CardIssuePoint) {
  return [cardIssuePoint.locality, cardIssuePoint.street, cardIssuePoint.building].filter(val => val).join(', ')
}

export interface CardIssuePointsService {
  findAll(ctx: Context, opts?: CardIssuePointFindOptions): Promise<PaginatedResult<CardIssuePoint>>
  findById(ctx: Context, id: Id): Promise<CardIssuePoint | undefined>
  findByIdNonDeleted(ctx: Context, id: Id): Promise<CardIssuePoint | undefined>
  add(ctx: Context, opts: AddCardIssuePointOpts): Promise<Id>
  update(ctx: Context, id: Id, opts: UpdateCardIssuePointOpts): Promise<void>
  delete(ctx: Context, id: Id): Promise<void>
}

export interface CardIssuePointsRepository {
  findAll(tx: ROTransaction, opts?: CardIssuePointFindOptions): Promise<PaginatedResult<CardIssuePoint>>
  findById(tx: ROTransaction, id: Id): Promise<CardIssuePoint | undefined>
  findByIdNonDeleted(tx: ROTransaction, id: Id): Promise<CardIssuePoint | undefined>
  save(tx: RWTransaction, cardIssuePoint: CardIssuePoint): Promise<void>
  delete(tx: RWTransaction, id: Id, deletedAt: Date): Promise<void>
}
